export enum DateRange {
  day0 = "day0",
  day1 = "day1",
  week0 = "week0",
  week1 = "week1",
  month0 = "month0",
  month1 = "month1",
  custom = "custom",
}
